import React, { useState } from 'react'
import { Box, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

type ProgressBarProps = {
  height: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ height }): JSX.Element => {
  const classes = useStyles()
  const [scrolled, setScrolled] = useState<string>('0%')

  const scrollProgress = () => {
    const scrollPx = document.documentElement.scrollTop
    const winHeightPx = document.documentElement.scrollHeight - document.documentElement.clientHeight
    setScrolled(`${(scrollPx / winHeightPx) * 100}%`)
  }

  const ref = () => {
    window.addEventListener('scroll', scrollProgress)
  }

  return (
    <Box className={classes.progress} width="100%" height={height} ref={ref}>
      <Box className={classes.progress_bar} width={scrolled} height={height} />
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  progress: {
    backgroundColor: palette.text.secondary,
  },
  progress_bar: {
    backgroundColor: palette.error.main,
    transition: '0s',
  },
}))
